import React from 'react'
import { Outlet } from 'react-router-dom'

const LeaveApprovalDisapprovalOutlet = () => {
    return (
        <div className='leaves'>
            <Outlet />
        </div>
    )
}

export default LeaveApprovalDisapprovalOutlet